export default __webpack_public_path__ + "static/media/1BHK S.ccc91ecd.png";